// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4047":"b1fa36a2","4737":"4157e60c"}[chunkId] + ".chunk.css";
};